'use client';

import ServiceLayout from '@/components/layout/service/ServiceLayout';

interface HubNewsLayoutProps {
    children: React.ReactNode;
}

export default function layout({ children }: HubNewsLayoutProps) {
    return <ServiceLayout>{children}</ServiceLayout>;
}
